(function () {
    if (customElements.get('tesla-scroll-hero')) return;
    var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
    var smooth = function (t) { return t * t * (3 - 2 * t); };

    class TeslaScrollHero extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.sticky = this.querySelector('.tsh__sticky');
        this.intro = this.querySelector('[data-intro]');
        this.captions = Array.prototype.slice.call(this.querySelectorAll('[data-caption]'));
        this.cta = this.querySelector('[data-cta]');
        this.hint = this.querySelector('[data-hint]');
        this.bar = this.querySelector('[data-bar]');
        this.current = 0;
        this.target = 0;
        this.running = false;
        this.duration = 0;

        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
        var src = (mobile && this.dataset.videoMobile) ? this.dataset.videoMobile : this.dataset.videoDesktop;

        if (reduced || !src) { this.classList.add('is-static'); this.bindCta(); return; }

        this.measureOffset();
        this.onResize = this.measureOffset.bind(this);
        window.addEventListener('resize', this.onResize, { passive: true });

        this.video.addEventListener('loadedmetadata', this.onMeta.bind(this), { once: true });
        this.video.addEventListener('error', this.fallback.bind(this), { once: true });
        this.video.src = src;
        this.video.load();
        this.failTimer = setTimeout(this.fallback.bind(this), 8000);

        this.observer = new IntersectionObserver(function (entries) {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.start(); else this.stop();
        }.bind(this), { rootMargin: '200px 0px 200px 0px' });
        this.observer.observe(this);

        this.bindCta();
        this.prime = function () {
          var v = this.video;
          var pr = v.play();
          if (pr && pr.then) pr.then(function () { v.pause(); }).catch(function () {});
        }.bind(this);
        window.addEventListener('touchstart', this.prime, { passive: true, once: true });
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      bindCta() {
        var link = this.querySelector('[data-scroll-next]');
        if (!link) return;
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var wrap = this.closest('.shopify-section');
          var next = wrap && wrap.nextElementSibling;
          if (next) {
            var top = next.getBoundingClientRect().top + window.pageYOffset - (parseFloat(getComputedStyle(this).getPropertyValue('--tsh-offset')) || 0);
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }.bind(this));
      }

      measureOffset() {
        var off = 0;
        var candidates = document.querySelectorAll('header, .header, [id*="header"]');
        for (var i = 0; i < candidates.length; i++) {
          var cs = getComputedStyle(candidates[i]);
          if (cs.position === 'sticky' || cs.position === 'fixed') {
            var r = candidates[i].getBoundingClientRect();
            if (r.top <= 1 && r.height > 20 && r.height < 200) { off = Math.max(off, r.bottom); }
          }
        }
        this.style.setProperty('--tsh-offset', Math.round(off) + 'px');
      }

      onMeta() {
        clearTimeout(this.failTimer);
        this.duration = this.video.duration || 0;
        if (!this.duration || !isFinite(this.duration)) { this.fallback(); return; }
        this.video.currentTime = 0.001;
        this.classList.add('is-ready');
        this.update(true);
        if (this.inView) this.start();
      }

      fallback() {
        clearTimeout(this.failTimer);
        if (this.classList.contains('is-ready')) return;
        this.stop();
        this.classList.add('is-static');
      }

      progress() {
        var rect = this.getBoundingClientRect();
        var off = parseFloat(getComputedStyle(this).getPropertyValue('--tsh-offset')) || 0;
        var total = rect.height - this.sticky.offsetHeight;
        if (total <= 0) return 0;
        return clamp((off - rect.top) / total, 0, 1);
      }

      start() { if (this.running || !this.duration) return; this.running = true; this.loop(); }
      stop() { this.running = false; if (this.raf) cancelAnimationFrame(this.raf); }
      loop() {
        if (!this.running) return;
        this.update(false);
        this.raf = requestAnimationFrame(this.loop.bind(this));
      }

      update(force) {
        var p = this.progress();
        this.target = p * this.duration * 0.995;
        this.current += (this.target - this.current) * (force ? 1 : 0.16);
        if (Math.abs(this.target - this.current) < 0.003) this.current = this.target;
        if (this.duration && !this.video.seeking && Math.abs(this.video.currentTime - this.current) > 0.015) {
          this.video.currentTime = this.current;
        }
        this.paint(p);
      }

      paint(p) {
        if (this.bar) this.bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        if (this.hint) this.hint.style.opacity = String(clamp(1 - p / 0.05, 0, 1));
        if (this.intro) {
          var o = 1 - smooth(clamp((p - 0.1) / 0.12, 0, 1));
          this.intro.style.opacity = o.toFixed(3);
          this.intro.style.transform = 'translate3d(0,' + (-p * 60).toFixed(1) + 'px,0)';
        }
        var n = this.captions.length;
        if (n) {
          var start = 0.24, end = 0.86, seg = (end - start) / n, fade = Math.min(0.05, seg / 3);
          for (var i = 0; i < n; i++) {
            var s = start + seg * i, e = s + seg;
            var a = smooth(clamp((p - s) / fade, 0, 1)) * (1 - smooth(clamp((p - (e - fade)) / fade, 0, 1)));
            var el = this.captions[i];
            el.style.opacity = a.toFixed(3);
            el.style.transform = 'translate3d(0,' + ((1 - a) * 24).toFixed(1) + 'px,0)';
          }
        }
        if (this.cta) {
          var c = smooth(clamp((p - 0.88) / 0.08, 0, 1));
          this.cta.style.opacity = c.toFixed(3);
          this.cta.classList.toggle('is-on', c > 0.5);
        }
      }
    }
    customElements.define('tesla-scroll-hero', TeslaScrollHero);
  })();
